import { defineStore } from 'pinia';

export const useRetailersStore = defineStore('retailers', {
    state: () => {
        return {
            locations:[],
            searching:false,
            zip:null,
            coords:{
                lat:null,
                lng:null
            }
        }
    },
    actions: {
        async geoLocate(){
            this.searching = true;

            navigator.geolocation.getCurrentPosition(async (position) => {
                this.coords.lat = position.coords.latitude;
                this.coords.lng = position.coords.longitude;
                this.zip = '';
                await this.getLocations();
            }, () => {
                alert('To search by current location, you must allow the browser to locate your current location.');
                this.searching = false;
            });
        },
        async getLocations(withZip = false){
            this.searching = true;
            let url = '/cw/locator/';
            if(withZip){
                if(!this.zip || !this.zip.length == 5){
                    alert('Please enter a valid US Zip Code');
                    this.searching = false;
                    return false;
                }
                url += this.zip;
            } else {
                url += this.coords.lat + ',' + this.coords.lng
            }
            try{
                if(window.gtag){
                    window.gtag('event', 'retail_locator_search');
                }

                let response = await fetch(url);
                response = await response.json();
                if(response.status && response.locations && response.locations.length){
                    if(withZip){
                        this.coords.lat = parseFloat(response.locations[0].Latitude);
                        this.coords.lng = parseFloat(response.locations[0].Longitude);
                    }
                    this.locations = response.locations;
                    setTimeout(function(){
                        document.querySelector('.themap').scrollIntoView();
                    }, 500);
                } else {
                    alert('Sorry we were not able to find any locations for your location, please try again.');
                }

            } catch(e){
                alert('Sorry we were not able to find any locations for your location, please try again.');
            }
            this.searching = false;
        }
    }
})
